<div class="Dialog Dialog--finder">
  <mat-toolbar color="primary" class="Dialog__header">
    <h2 class="Dialog__title" mat-dialog-title>{{ title }}</h2>
    <span class="flex-1"></span>
    <button mat-icon-button type="button" (click)="dismiss()"><mat-icon>close</mat-icon></button>
  </mat-toolbar>
  <div class="Dialog__content" mat-dialog-content>
    <div class="p-2">
      <p *ngIf="message" class="mb-2 text-gray-700">{{ message }}</p>
      <aw-autocomplete
        appearance="fill"
        *ngIf="!data.request"
        [service]="data.service"
        [method]="data.method ? data.method : 'autocomplete'"
        [displayProperty]="data.displayProperty"
        [filter]="data.filter"
        [options]="data.options"
        [excludes]="data.excludes"
        [optionLabelPredicate]="data.optionLabelPredicate"
        [placeholder]="title"
        (onSelect)="onSelect($event)"
      ></aw-autocomplete>
      <aw-autocomplete-2
        appearance="fill"
        *ngIf="data.request"
        [request]="data.request"
        appearance="fill"
        [displayProperty]="data.displayProperty"
        [excludes]="data.excludes"
        [placeholder]="data.placeholder || title"
        (onSelect)="onSelect($event)"
      ></aw-autocomplete-2>
    </div>
  </div>
  <!-- <div class="Dialog__actions" mat-dialog-actions>
        <span class="flex-1"></span>
        <button type="button" mat-button
        (click)="dialogRef.close()">Avbryt</button>
        <button type="button" mat-raised-button color="primary"
        (click)="dialogRef.close(true)">OK</button>
    </div> -->
</div>
